const transaction_modes = Object.freeze({
    'In-branch/Office': 'A',
    'ATM': 'B',
    'Electronic transaction': 'C',
    'Courier': 'D',
    'Mail Deposit': 'E',
    'Other': 'F',
    'Digital Currency': 'G',
    'Online Banking': 'H',
    'Manual Order': 'I'
})

const legal_form = Object.freeze({
    "Private Limited Company (Besloten Vennootschap)": "BV",
    "Cooperative (Coöperatie)": "COOP",
    "Joint Stock Limited Partnership (Comm. Venootschap op Aandelen)": "CV",
    "Proprietary Business (Eenmanszaak)": "EENM",
    "Limited Partnership (Commanditaire Vennootschap)": "LP",
    "Partnership (Maatschap)": "MAAT",
    "Limited Liability Company (Naamloze Vennootschap)": "NV",
    "Other": "OTH",
    "Private Foundations (Stichting Particuliere Fonds)": "PF",
    "Foundation (Stichting)": "STIC",
    "Assocation (Vereniging)": "VERE",
    "Firm (Vennootschap onder Firma)": "VOF",
})

const account_types = Object.freeze({
    'Business': 'BUS',
    'Personal Current': 'PCUR',
    'Savings': 'SAV',
    'Trust Account': 'TRUST',
    'Trading Account': 'TRAD',
    'Third Party Account': 'TPA',
    'Current Account': 'CUR',
    'E-Wallet' : 'EWAL',
    'Credit Card': 'CC',
    'Other': 'OTH'
})


const transaction_direction = Object.freeze({
    'Bank to Merchant': 'Bank to Merchant',
    'Merchant to Bank': 'Merchant to Bank',
})

const transfer_type = Object.freeze({
    'Player Deposit': 'Player Deposit',
    'Player Withdrawal': 'Player Withdrawal',
})

const status_code = Object.freeze({
    'Active': 'ACT',
    'Inactive': 'INACT',
    'Dormant': 'DOR',
    'Suspended': 'SUSP',
    'Frozen': 'FRZ',
    'Seized': 'SZD',
    'Other': 'O'
})




const identification_types = Object.freeze({
    'Driving license': 'A',
    'Drivers License': 'A',
    'National Identity Card': 'B',
    'Passport': 'C',
    'Other': 'D'
})

const address_types = Object.freeze({
    'Business': 2,
    'Private': 1,
})
const gender_vars = Object.freeze({
    'Male': 'M',
    'Female': 'F'
})
const gender_inverse = Object.freeze({
    'M': 'Male',
    'F': 'Female'
})
const funds_code = Object.freeze({
    "Deposit": "A",
    "Electronic Funds Transfer": "B",
    "Currency exchange": "C",
    "Casino chips": "D",
    "Bank draft": "E",
    "Money order": "F",
    "Traveler’s cheques": "G",
    "Life insurance policy": "H",
    "Real estate": "I",
    "Securities": "J",
    "Cash": "K",
    "Internal Transfer": "L",
    "Hotel Transaction": "M",
    "NGO’s, Charity": "N",
    "Other": "O",
    "Cheque": "P",
    "Withdrawal": "W"
})

const currencies_local = [
    'ANG',
    'XCG',
    'USD',
    'EUR',
]


const countries = Object.freeze({
    "UNKNOWN": "-",
    "unknown": "-",
    "Unknown": "-",
    "AFGHANISTAN": "AF",
    "ALBANIA": "AL",
    "ALGERIA": "DZ",
    "AMERICAN SAMOA": "AS",
    "ANDORRA": "AD",
    "ANGOLA": "AO",
    "ANGUILLA": "AI",
    "ANTARCTICA": "AQ",
    "ANTIGUA AND BARBUDA": "AG",
    "ARGENTINA": "AR",
    "ARMENIA": "AM",
    "ARUBA": "AW",
    "AUSTRALIA": "AU",
    "AUSTRIA": "AT",
    "AZERBAIJAN": "AZ",
    "BAHAMAS": "BS",
    "BAHRAIN": "BH",
    "BANGLADESH": "BD",
    "BARBADOS": "BB",
    "BELARUS": "BY",
    "BELGIUM": "BE",
    "BELIZE": "BZ",
    "BENIN": "BJ",
    "BERMUDA": "BM",
    "BHUTAN": "BT",
    "BOLIVIA": "BO",
    "BONAIRE, SAINT EUSTATIUS and SABA": "BQ",
    "BOSNIA AND HERZEGOVINA": "BA",
    "BOTSWANA": "BW",
    "BOUVET ISLAND": "BV",
    "BRAZIL": "BR",
    "BRITISH INDIAN OCEAN TERRITORY": "IO",
    "BRUNEI DARUSSALAM": "BN",
    "BULGARIA": "BG",
    "BURKINA FASO": "BF",
    "BURUNDI": "BI",
    "CAMBODIA": "KH",
    "CAMEROON": "CM",
    "CANADA": "CA",
    "CAPE VERDE": "CV",
    "CAYMAN ISLANDS": "KY",
    "CENTRAL AFRICAN REPUBLIC": "CF",
    "CHAD": "TD",
    "CHILE": "CL",
    "CHINA": "CN",
    "CHRISTMAS ISLAND": "CX",
    "COCOS (KEELING) ISLANDS": "CC",
    "COLOMBIA": "CO",
    "COMOROS": "KM",
    "CONGO": "CG",
    "COOK ISLANDS": "CK",
    "COSTA RICA": "CR",
    "COTE D'IVOIRE": "CI",
    "CROATIA": "HR",
    "CUBA": "CU",
    "CURACAO": "CW",
    "CYPRUS": "CY",
    "CZECH REPUBLIC": "CZ",
    "DENMARK": "DK",
    "DJIBOUTI": "DJ",
    "DOMINICA": "DM",
    "DOMINICAN REPUBLIC": "DO",
    "ECUADOR": "EC",
    "EGYPT": "EG",
    "EL SALVADOR": "SV",
    "EQUATORIAL GUINEA": "GQ",
    "ERITREA": "ER",
    "ESTONIA": "EE",
    "ETHIOPIA": "ET",
    "FALKLAND ISLANDS (MALVINAS)": "FK",
    "FAROE ISLANDS": "FO",
    "FIJI": "FJ",
    "FINLAND": "FI",
    "FRANCE": "FR",
    "FRENCH GUIANA": "GF",
    "FRENCH POLYNESIA": "PF",
    "FRENCH SOUTHERN TERRITORIES": "TF",
    "GABON": "GA",
    "GAMBIA": "GM",
    "GEORGIA": "GE",
    "GERMANY": "DE",
    "GHANA": "GH",
    "GIBRALTAR": "GI",
    "GREECE": "GR",
    "GREENLAND": "GL",
    "GRENADA": "GD",
    "GUADELOUPE": "GP",
    "GUAM": "GU",
    "GUATEMALA": "GT",
    "GUERNSEY": "GG",
    "GUINEA": "GN",
    "GUINEA-BISSAU": "GW",
    "GUYANA": "GY",
    "HAITI": "HT",
    "HEARD ISLAND AND MCDONALD ISLANDS": "HM",
    "HOLY SEE (VATICAN CITY STATE)": "VA",
    "HONDURAS": "HN",
    "HONG KONG": "HK",
    "HUNGARY": "HU",
    "ICELAND": "IS",
    "INDIA": "IN",
    "INDONESIA": "ID",
    "IRAN, ISLAMIC REPUBLIC OF": "IR",
    "IRAQ": "IQ",
    "IRELAND": "IE",
    "ISLE OF MAN": "IM",
    "ISRAEL": "IL",
    "ITALY": "IT",
    "JAMAICA": "JM",
    "JAPAN": "JP",
    "JERSEY": "JE",
    "JORDAN": "JO",
    "KAZAKHSTAN": "KZ",
    "KENYA": "KE",
    "KIRIBATI": "KI",
    "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF": "KP",
    "KOREA, REPUBLIC OF": "KR",
    "KOSOVO": "XK",
    "KOSOVO (Old - KS)": "KS",
    "KUWAIT": "KW",
    "KYRGYZSTAN": "KG",
    "LAO PEOPLE'S DEMOCRATIC REPUBLIC": "LA",
    "LATVIA": "LV",
    "LEBANON": "LB",
    "LESOTHO": "LS",
    "LIBERIA": "LR",
    "LIBYA": "LY",
    "LIECHTENSTEIN": "LI",
    "LITHUANIA": "LT",
    "LUXEMBOURG": "LU",
    "MACAO": "MO",
    "MADAGASCAR": "MG",
    "MALAWI": "MW",
    "MALAYSIA": "MY",
    "MALDIVES": "MV",
    "MALI": "ML",
    "MALTA": "MT",
    "MARSHALL ISLANDS": "MH",
    "MARTINIQUE": "MQ",
    "MAURITANIA": "MR",
    "MAURITIUS": "MU",
    "MAYOTTE": "YT",
    "MEXICO": "MX",
    "MICRONESIA, FEDERATED STATES OF": "FM",
    "MOLDOVA, REPUBLIC OF": "MD",
    "MONACO": "MC",
    "MONGOLIA": "MN",
    "Montenegro": "ME",
    "MONTSERRAT": "MS",
    "MOROCCO": "MA",
    "MOZAMBIQUE": "MZ",
    "MYANMAR": "MM",
    "NAMIBIA": "NA",
    "NAURU": "NR",
    "NEPAL": "NP",
    "NETHERLANDS": "NL",
    "NEW CALEDONIA": "NC",
    "NEW ZEALAND": "NZ",
    "NICARAGUA": "NI",
    "NIGER": "NE",
    "NIGERIA": "NG",
    "NIUE": "NU",
    "NORFOLK ISLAND": "NF",
    "NORTHERN MARIANA ISLANDS": "MP",
    "NORWAY": "NO",
    "OMAN": "OM",
    "PAKISTAN": "PK",
    "PALAU": "PW",
    "PANAMA": "PA",
    "PAPUA NEW GUINEA": "PG",
    "PARAGUAY": "PY",
    "PERU": "PE",
    "PHILIPPINES": "PH",
    "PITCAIRN": "PN",
    "POLAND": "PL",
    "PORTUGAL": "PT",
    "PUERTO RICO": "PR",
    "QATAR": "QA",
    "REUNION": "RE",
    "ROMANIA": "RO",
    "RUSSIAN FEDERATION": "RU",
    "RWANDA": "RW",
    "SAINT BARTHÉLEMY": "BL",
    "SAINT HELENA": "SH",
    "SAINT KITTS AND NEVIS": "KN",
    "SAINT LUCIA": "LC",
    "SAINT MARTIN (FRENCH PART)": "MF",
    "SAINT PIERRE AND MIQUELON": "PM",
    "SAINT VINCENT AND THE GRENADINES": "VC",
    "SAMOA": "WS",
    "SAN MARINO": "SM",
    "SAO TOME AND PRINCIPE": "ST",
    "SAUDI ARABIA": "SA",
    "SENEGAL": "SN",
    "SERBIA": "RS",
    "SEYCHELLES": "SC",
    "SIERRA LEONE": "SL",
    "SINGAPORE": "SG",
    "SINT MAARTEN (Dutch part)": "SX",
    "SLOVAKIA": "SK",
    "SLOVENIA": "SI",
    "SOLOMON ISLANDS": "SB",
    "SOMALIA": "SO",
    "SOUTH AFRICA": "ZA",
    "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS": "GS",
    "SOUTH SUDAN": "SS",
    "SPAIN": "ES",
    "SRI LANKA": "LK",
    "STATE OF PALESTINE": "PS",
    "SUDAN": "SD",
    "SURINAME": "SR",
    "SVALBARD AND JAN MAYEN": "SJ",
    "SWEDEN": "SE",
    "SWITZERLAND": "CH",
    "SYRIAN ARAB REPUBLIC": "SY",
    "TAIWAN, PROVINCE OF CHINA": "TW",
    "TAJIKISTAN": "TJ",
    "TANZANIA, UNITED REPUBLIC OF": "TZ",
    "THAILAND": "TH",
    "TIMOR-LESTE": "TL",
    "TOGO": "TG",
    "TOKELAU": "TK",
    "TONGA": "TO",
    "TRINIDAD AND TOBAGO": "TT",
    "TUNISIA": "TN",
    "TURKEY": "TR",
    "TURKMENISTAN": "TM",
    "TURKS AND CAICOS ISLANDS": "TC",
    "TUVALU": "TV",
    "UGANDA": "UG",
    "UKRAINE": "UA",
    "UNITED ARAB EMIRATES": "AE",
    "UNITED KINGDOM": "GB",
    "UNITED STATES": "US",
    "UNITED STATES MINOR OUTLYING ISLANDS": "UM",
    "URUGUAY": "UY",
    "UZBEKISTAN": "UZ",
    "VANUATU": "VU",
    "VENEZUELA": "VE",
    "VIET NAM": "VN",
    "VIRGIN ISLANDS, BRITISH": "VG",
    "VIRGIN ISLANDS, U.S.": "VI",
    "WALLIS AND FUTUNA": "WF",
    "WESTERN SAHARA": "EH",
    "YEMEN": "YE",
    "ZAMBIA": "ZM",
    "ZIMBABWE": "ZW"
})
const iso_to_country = Object.freeze({
    "-":  "UNKNOWN",
    "AF": "AFGHANISTAN",
    "AL": "ALBANIA",
    "DZ": "ALGERIA",
    "AS": "AMERICAN SAMOA",
    "AD": "ANDORRA",
    "AO": "ANGOLA",
    "AI": "ANGUILLA",
    "AQ": "ANTARCTICA",
    "AG": "ANTIGUA AND BARBUDA",
    "AR": "ARGENTINA",
    "AM": "ARMENIA",
    "AW": "ARUBA",
    "AU": "AUSTRALIA",
    "AT": "AUSTRIA",
    "AZ": "AZERBAIJAN",
    "BS": "BAHAMAS",
    "BH": "BAHRAIN",
    "BD": "BANGLADESH",
    "BB": "BARBADOS",
    "BY": "BELARUS",
    "BE": "BELGIUM",
    "BZ": "BELIZE",
    "BJ": "BENIN",
    "BM": "BERMUDA",
    "BT": "BHUTAN",
    "BO": "BOLIVIA",
    "BQ": "BONAIRE, SAINT EUSTATIUS and SABA",
    "BA": "BOSNIA AND HERZEGOVINA",
    "BW": "BOTSWANA",
    "BV": "BOUVET ISLAND",
    "BR": "BRAZIL",
    "IO": "BRITISH INDIAN OCEAN TERRITORY",
    "BN": "BRUNEI DARUSSALAM",
    "BG": "BULGARIA",
    "BF": "BURKINA FASO",
    "BI": "BURUNDI",
    "KH": "CAMBODIA",
    "CM": "CAMEROON",
    "CA": "CANADA",
    "CV": "CAPE VERDE",
    "KY": "CAYMAN ISLANDS",
    "CF": "CENTRAL AFRICAN REPUBLIC",
    "TD": "CHAD",
    "CL": "CHILE",
    "CN": "CHINA",
    "CX": "CHRISTMAS ISLAND",
    "CC": "COCOS (KEELING) ISLANDS",
    "CO": "COLOMBIA",
    "KM": "COMOROS",
    "CG": "CONGO",
    "CK": "COOK ISLANDS",
    "CR": "COSTA RICA",
    "CI": "COTE D'IVOIRE",
    "HR": "CROATIA",
    "CU": "CUBA",
    "CW": "CURACAO",
    "CY": "CYPRUS",
    "CZ": "CZECH REPUBLIC",
    "DK": "DENMARK",
    "DJ": "DJIBOUTI",
    "DM": "DOMINICA",
    "DO": "DOMINICAN REPUBLIC",
    "EC": "ECUADOR",
    "EG": "EGYPT",
    "SV": "EL SALVADOR",
    "GQ": "EQUATORIAL GUINEA",
    "ER": "ERITREA",
    "EE": "ESTONIA",
    "ET": "ETHIOPIA",
    "FK": "FALKLAND ISLANDS (MALVINAS)",
    "FO": "FAROE ISLANDS",
    "FJ": "FIJI",
    "FI": "FINLAND",
    "FR": "FRANCE",
    "GF": "FRENCH GUIANA",
    "PF": "FRENCH POLYNESIA",
    "TF": "FRENCH SOUTHERN TERRITORIES",
    "GA": "GABON",
    "GM": "GAMBIA",
    "GE": "GEORGIA",
    "DE": "GERMANY",
    "GH": "GHANA",
    "GI": "GIBRALTAR",
    "GR": "GREECE",
    "GL": "GREENLAND",
    "GD": "GRENADA",
    "GP": "GUADELOUPE",
    "GU": "GUAM",
    "GT": "GUATEMALA",
    "GG": "GUERNSEY",
    "GN": "GUINEA",
    "GW": "GUINEA-BISSAU",
    "GY": "GUYANA",
    "HT": "HAITI",
    "HM": "HEARD ISLAND AND MCDONALD ISLANDS",
    "VA": "HOLY SEE (VATICAN CITY STATE)",
    "HN": "HONDURAS",
    "HK": "HONG KONG",
    "HU": "HUNGARY",
    "IS": "ICELAND",
    "IN": "INDIA",
    "ID": "INDONESIA",
    "IR": "IRAN, ISLAMIC REPUBLIC OF",
    "IQ": "IRAQ",
    "IE": "IRELAND",
    "IM": "ISLE OF MAN",
    "IL": "ISRAEL",
    "IT": "ITALY",
    "JM": "JAMAICA",
    "JP": "JAPAN",
    "JE": "JERSEY",
    "JO": "JORDAN",
    "KZ": "KAZAKHSTAN",
    "KE": "KENYA",
    "KI": "KIRIBATI",
    "KP": "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF",
    "KR": "KOREA, REPUBLIC OF",
    "XK": "KOSOVO",
    "KS": "KOSOVO (Old - KS)",
    "KW": "KUWAIT",
    "KG": "KYRGYZSTAN",
    "LA": "LAO PEOPLE'S DEMOCRATIC REPUBLIC",
    "LV": "LATVIA",
    "LB": "LEBANON",
    "LS": "LESOTHO",
    "LR": "LIBERIA",
    "LY": "LIBYA",
    "LI": "LIECHTENSTEIN",
    "LT": "LITHUANIA",
    "LU": "LUXEMBOURG",
    "MO": "MACAO",
    "MG": "MADAGASCAR",
    "MW": "MALAWI",
    "MY": "MALAYSIA",
    "MV": "MALDIVES",
    "ML": "MALI",
    "MT": "MALTA",
    "MH": "MARSHALL ISLANDS",
    "MQ": "MARTINIQUE",
    "MR": "MAURITANIA",
    "MU": "MAURITIUS",
    "YT": "MAYOTTE",
    "MX": "MEXICO",
    "FM": "MICRONESIA, FEDERATED STATES OF",
    "MD": "MOLDOVA, REPUBLIC OF",
    "MC": "MONACO",
    "MN": "MONGOLIA",
    "ME": "Montenegro",
    "MS": "MONTSERRAT",
    "MA": "MOROCCO",
    "MZ": "MOZAMBIQUE",
    "MM": "MYANMAR",
    "NA": "NAMIBIA",
    "NR": "NAURU",
    "NP": "NEPAL",
    "NL": "NETHERLANDS",
    "NC": "NEW CALEDONIA",
    "NZ": "NEW ZEALAND",
    "NI": "NICARAGUA",
    "NE": "NIGER",
    "NG": "NIGERIA",
    "NU": "NIUE",
    "NF": "NORFOLK ISLAND",
    "MP": "NORTHERN MARIANA ISLANDS",
    "NO": "NORWAY",
    "OM": "OMAN",
    "PK": "PAKISTAN",
    "PW": "PALAU",
    "PA": "PANAMA",
    "PG": "PAPUA NEW GUINEA",
    "PY": "PARAGUAY",
    "PE": "PERU",
    "PH": "PHILIPPINES",
    "PN": "PITCAIRN",
    "PL": "POLAND",
    "PT": "PORTUGAL",
    "PR": "PUERTO RICO",
    "QA": "QATAR",
    "RE": "REUNION",
    "RO": "ROMANIA",
    "RU": "RUSSIAN FEDERATION",
    "RW": "RWANDA",
    "BL": "SAINT BARTHÉLEMY",
    "SH": "SAINT HELENA",
    "KN": "SAINT KITTS AND NEVIS",
    "LC": "SAINT LUCIA",
    "MF": "SAINT MARTIN (FRENCH PART)",
    "PM": "SAINT PIERRE AND MIQUELON",
    "VC": "SAINT VINCENT AND THE GRENADINES",
    "WS": "SAMOA",
    "SM": "SAN MARINO",
    "ST": "SAO TOME AND PRINCIPE",
    "SA": "SAUDI ARABIA",
    "SN": "SENEGAL",
    "RS": "SERBIA",
    "SC": "SEYCHELLES",
    "SL": "SIERRA LEONE",
    "SG": "SINGAPORE",
    "SX": "SINT MAARTEN (Dutch part)",
    "SK": "SLOVAKIA",
    "SI": "SLOVENIA",
    "SB": "SOLOMON ISLANDS",
    "SO": "SOMALIA",
    "ZA": "SOUTH AFRICA",
    "GS": "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS",
    "SS": "SOUTH SUDAN",
    "ES": "SPAIN",
    "LK": "SRI LANKA",
    "PS": "STATE OF PALESTINE",
    "SD": "SUDAN",
    "SR": "SURINAME",
    "SJ": "SVALBARD AND JAN MAYEN",
    "SE": "SWEDEN",
    "CH": "SWITZERLAND",
    "SY": "SYRIAN ARAB REPUBLIC",
    "TW": "TAIWAN, PROVINCE OF CHINA",
    "TJ": "TAJIKISTAN",
    "TZ": "TANZANIA, UNITED REPUBLIC OF",
    "TH": "THAILAND",
    "TL": "TIMOR-LESTE",
    "TG": "TOGO",
    "TK": "TOKELAU",
    "TO": "TONGA",
    "TT": "TRINIDAD AND TOBAGO",
    "TN": "TUNISIA",
    "TR": "TURKEY",
    "TM": "TURKMENISTAN",
    "TC": "TURKS AND CAICOS ISLANDS",
    "TV": "TUVALU",
    "UG": "UGANDA",
    "UA": "UKRAINE",
    "AE": "UNITED ARAB EMIRATES",
    "GB": "UNITED KINGDOM",
    "US": "UNITED STATES",
    "UM": "UNITED STATES MINOR OUTLYING ISLANDS",
    "UY": "URUGUAY",
    "UZ": "UZBEKISTAN",
    "VU": "VANUATU",
    "VE": "VENEZUELA",
    "VN": "VIET NAM",
    "VG": "VIRGIN ISLANDS, BRITISH",
    "VI": "VIRGIN ISLANDS, U.S.",
    "WF": "WALLIS AND FUTUNA",
    "EH": "WESTERN SAHARA",
    "YE": "YEMEN",
    "ZM": "ZAMBIA",
    "ZW": "ZIMBABWE"
})


const currencies = Object.freeze({
    "XCG": "Caribbean Guilders",
    "AFN": "Afghan Afghani",
    "DZD": "Algerian Dinar",
    "AOA": "Angolan Kwanza",
    "ARS": "Argentine Peso",
    "AWG": "Aruban Guilder",
    "AUD": "Australian Dollar",
    "AZN": "Azerbaijanian Manat",
    "BSD": "Bahamian Dollar",
    "BHD": "Bahraini Dinar",
    "BBD": "Barbados Dollar",
    "BYR": "Belarussian Ruble",
    "BZD": "Belize Dollar",
    "BMD": "Bermudian Dollar",
    "BOB": "Boliviano",
    "BRL": "Brazilian Real",
    "BND": "Brunei Dollar",
    "BGN": "Bulgarian Lev",
    "BIF": "Burundi Franc",
    "CAD": "Canadian Dollar",
    "KYD": "Cayman Islands Dollar",
    "CLP": "Chilean Peso",
    "COP": "Colombian Peso",
    "KMF": "Comorian Franc",
    "CDF": "Congolese franc",
    "BAM": "Convertible Mark",
    "NIO": "Cordoba oro",
    "CRC": "Costa Rican Colón",
    "HRK": "Croatian Kuna",
    "CUP": "Cuban Peso",
    "CZK": "Czech Koruna",
    "GMD": "Dalasi",
    "DKK": "Danish Krone",
    "KPW": "Democratic People's Republic of Korean Won",
    "DJF": "Djibouti Franc",
    "STD": "Dobra",
    "DOP": "Dominican Republic Peso",
    "XCD": "East Caribbean Dollar",
    "EGP": "Egyptian Pound",
    "SVC": "El Salvadorian Colón",
    "ERN": "Eritrean Nakfa",
    "CVE": "Escudo Caboverdiano",
    "ETB": "Ethiopian Birr",
    "EUR": "Euro",
    "FKP": "Falkland Pound",
    "FJD": "Fiji Dollar",
    "HUF": "Forint",
    "GHS": "Ghanaian cedi",
    "GIP": "Gibraltar Pound",
    "XAU": "Gold",
    "HTG": "Gourde",
    "PYG": "Guarani",
    "GNF": "Guinean franc",
    "GYD": "Guyana Dollar",
    "HKD": "Hong Kong Dollar",
    "UAH": "Hryvna",
    "ISK": "Icelandic Króna",
    "UKP": "Incorrectly used for GBP",
    "INR": "Indian Rupee",
    "IQD": "Iraqi Dinar",
    "JMD": "Jamaican Dollar",
    "JOD": "Jordanian Dinar",
    "KES": "Kenyan Shilling",
    "PGK": "Kina",
    "LAK": "Kip",
    "EEK": "Kroon",
    "KWD": "Kuwaiti Dinar",
    "AOK": "Kwanza",
    "MMK": "Kyat",
    "KGS": "Kyrgyzstani Som",
    "GEL": "Lari",
    "LVL": "Lats",
    "LBP": "Lebanese Pound",
    "ALL": "Lek",
    "HNL": "Lempira",
    "SLL": "Leone",
    "LRD": "Liberian Dollar",
    "LYD": "Libyan Dinar",
    "SZL": "Lilangeni",
    "LTL": "Litas",
    "LSL": "Loti",
    "MKD": "Macedonian Dinar",
    "MGA": "Malagasy ariary",
    "MWK": "Malawian Kwacha",
    "LSM": "Maloti",
    "MTP": "Maltese Pound, replaced by Maltese Lira",
    "MUR": "Mauritius Rupee",
    "MXN": "Mexican New Peso (replacement for Mexican Peso)",
    "MDL": "Moldavian Leu",
    "MAD": "Moroccan Dirham",
    "MZN": "Mozambican metical",
    "NGN": "Naira",
    "NAD": "Namibian Dollar",
    "NPR": "Nepalese Rupee",
    "ANG": "Netherlands Antilles Guilder",
    "PEN": "New Sol",
    "CDZ": "New Zaïre",
    "NZD": "New Zealand Dollar",
    "PLN": "New Zloty",
    "BTN": "Ngultrum",
    "XXX": "No currency",
    "NOK": "Norwegian Krone",
    "OMR": "Omani Rial",
    "MRO": "Ouguiya",
    "TOP": "Pa'anga",
    "PKR": "Pakistani Rupee",
    "MOP": "Pataca",
    "PHP": "Philippines Peso",
    "GBP": "Pound Sterling (United Kingdom Pound)",
    "BWP": "Pula",
    "QAR": "Qatari Riyal",
    "GTQ": "Quetzal",
    "ZAR": "Rand",
    "BUK": "Replaced by MMK",
    "KRW": "Republic of Korean Won",
    "KHR": "Riel",
    "MYR": "Ringgit (also known as Malaysian Dollar)",
    "RON": "Romanian new leu",
    "MVR": "Rufiyaa",
    "IDR": "Rupiah",
    "RUB": "Russian Federation Rouble (formerly RUR)",
    "RWF": "Rwandan Franc",
    "SAR": "Saudi Riyal",
    "RSD": "Serbian dinar",
    "SCR": "Seychelles Rupee",
    "ILS": "Shekel",
    "XAG": "Silver (one troy ounce)",
    "SGD": "Singapore Dollar",
    "SBD": "Solomon Islands Dollar",
    "SOS": "Somali Shilling",
    "SSP": "South Sudanese Pound",
    "LKR": "Sri Lankan Rupee",
    "SHP": "St Helena Pound",
    "SDG": "Sudanese pound",
    "SRD": "Surinamese dollar",
    "SEK": "Swedish Krona",
    "CHF": "Swiss Franc",
    "GNS": "Syli (also known as Guinea Franc)",
    "SYP": "Syrian Pound",
    "TWD": "Taiwan Dollar",
    "TJS": "Tajikistani somoni",
    "BDT": "Taka",
    "WST": "Tala",
    "TZS": "Tanzanian Shilling",
    "KZT": "Tenge",
    "TPE": "Timorian Escudo",
    "TTD": "Trinidad and Tobago Dollar",
    "MNT": "Tugrik",
    "TND": "Tunisian Dinar",
    "TRY": "Turkish lira",
    "TMT": "Turkmenistani manat",
    "UGX": "Ugandan shilling",
    "COU": "Unidad de Valor Real",
    "CLF": "Unidades de Fomento",
    "AED": "United Arab Emirates Dirham",
    "USD": "United States Dollar",
    "UYU": "Uruguayan New Peso",
    "UZS": "Uzbekistani Som",
    "VUV": "Vatu",
    "VEF": "Venezuelan Bolívar Fuerte",
    "VND": "Viet Nam Dông",
    "XOF": "West African Franc",
    "YER": "Yemeni Riyal",
    "JPY": "Yen",
    "CNY": "Yuan Renminbi",
    "CNH": "Yuan Renminbi (offshore)",
    "ZMW": "Zambian Kwacha"
})
  
const indicators = [
    "A0000111",
    "A0000114",
    "A0000133",
    "A0000211",
    "B0000111",
    "B0000114",
    "B0000137",
    "B0000138",
    "B0000139",
    "B0000162",
    "B0000211",
    "C0000111",
    "C0000114",
    "C0000135-1",
    "C0000135-2",
    "C0000135-3",
    "C0000135-4",
    "C0000135-5",
    "C0000211",
    "E0000111",
    "E0000114",
    "E0000133",
    "E0000211",
    "F0000111",
    "F0000114",
    "F0000133",
    "F0000211",
    "G0000111",
    "G0000114",
    "G0000135-1",
    "G0000135-2",
    "G0000135-3",
    "G0000135-4",
    "G0000135-5",
    "G0000211",
    "HB0000111",
    "HB0000114",
    "HB0000134",
    "HB0000211",
    "HJ0000111",
    "HJ0000114",
    "HJ0000134",
    "HJ0000211",
    "HV0000111",
    "HV0000114",
    "HV0000134",
    "HV0000211",
    "I0000111",
    "I0000114",
    "I0000211",
    "IRII0000111",
    "IRII0000114",
    "IRIL0000111",
    "IRIL0000114",
    "L0000111",
    "L0000114",
    "L0000138",
    "L0000162",
    "L0000211",
    "M0000111",
    "M0000114",
    "M0000134",
    "M0000137",
    "M0000211",
    "N0000111",
    "N0000114",
    "N0000135-1",
    "N0000135-2",
    "N0000135-3",
    "N0000135-4",
    "N0000135-5",
    "N0000211",
    "ORII0000111",
    "ORII0000114",
    "ORIL0000111",
    "ORIL0000114",
    "R0000111",
    "R0000114",
    "R0000211",
    "T0000111",
    "T0000114",
    "T0000141",
    "T0000211",
    "VA0000111",
    "VA0000114",
    "VA0000134",
    "VA0000211",
    "VC0000111",
    "VC0000114",
    "VC0000134",
    "VC0000211",
    "VK0000111",
    "VK0000114",
    "VK0000134",
    "VK0000211",
    "VN0000111",
    "VN0000114",
    "VN0000134",
    "VN0000211",
    "VR1020111",
    "VR1020114",
    "VR1020134",
    "VR1020211",
    "VT0000111",
    "VT0000114",
    "VT0000134",
    "VT0000211",
    "Z0000111",
    "Z0000114",
    "Z0000211"
]
  
const report_code = Object.freeze({
    'Additional Information Report': 'AIR',
	'Unusual Transaction Report': 'UTR'
})

const transmode_code = Object.freeze({
    'In-branch/Office': 'A',
    'ATM': 'B',
    'Electronic transaction (Wire Transfers)': 'C',
    'Courier': 'D',
    'Mail Deposit': 'E',
    'Other': 'F',
    'Digital Currency': 'G',
    'Online Banking': 'H',
    'Manual Order': 'I'
})
 


const party_role_type = Object.freeze({
    'Payee /Sender': 'A',
    'Beneficiary /Receiver': 'B',
    'Conductor': 'C',
    'Other': '-'
})


const fund_code_type = Object.freeze({
    'Deposit': 'A',
    'Electronic Funds Transfer': 'B',
    'Currency exchange': 'C',
    'Casino chips': 'D',
    'Bank draft': 'E',
    'Money order': 'F',
    'Traveler’s cheques': 'G',
    'Life insurance policy': 'H',
    'Real estate': 'I',
    'Securities': 'J',
    'Cash': 'K',
    'Internal Transfer': 'L',
    'Hotel Transaction': 'M',
    'NGO’s, Charity': 'N',
    'Other': 'O',
    'Cheque': 'P',
    'Withdrawal': 'W'
})


const communication_type = Object.freeze({
    'Mobile Phone': 'M',
    'Fax': 'F',
    'Landline Phone': 'L',
    'Pager': 'P',
})


module.exports = {
    transaction_modes,
    account_types,
    status_code,
    funds_code,
    countries,
    currencies,
    currencies_local,
    indicators,
    iso_to_country,
    report_code,
    transmode_code,
    party_role_type,
    fund_code_type,
    address_types,
    gender_vars,
    gender_inverse,
    identification_types,
    communication_type,
    transaction_direction,
    legal_form,
    transfer_type
}